<template>
  <el-dialog
      :title="title"
      :visible.sync="dialogVisible"
      width="50%"
      :before-close="handleClose">
    <div class="monitorList-area">
        <div class="contents">
          <div id="myDetailPlayer" class="canvas-img"></div>
        </div>
    </div>
  </el-dialog>
</template>

<script>
import EZUIKit from "ezuikit-js";
import { getStorage,setStorage,removeStorage } from "@/utils/localStorage";
export default {
  name: "MonitorDetail",
  data() {
    return {
      title:'',
      player:null,
      dialogVisible:false,//是否打开对话框
    };
  },
  props: {
    id: String
  },
  created() {
  },
  computed: {
  },
  mounted() {
    window.openVideo=this.openVideoDialog;
  },
  methods: {

    handleClose(done) {
      done();
    },
    openVideoDialog(title,url){
      this.title=title;
      this.dialogVisible=true;
      //  显示监控
      this.$nextTick(() => {
        if(!this.player){
          const appToken = JSON.parse(getStorage("appToken"));
          this.player =  new EZUIKit.EZUIKitPlayer({
            autoplay: true,
            id: 'myDetailPlayer',
            accessToken: appToken.accessToken,
            url,
            splitBasis: 0,
            template: "simple",
            width: 600,
            height: 400
          });

        }
        this.player.stop();
        this.player.opt.url=url;
        this.player.play();
      })
    }
  }
};
</script>

<style scoped>
.monitorList-area {
  width: 100%;
  height: 100%;
  background: #708090;
}
.canvas-img {
  width: 100%;
  height: 420px;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>